import { domainEventDispatcher } from "./DomainEventDispatcher.js";
import { MovimientoInventarioActualizado } from "./MovimientoInventarioActualizado.event.js";
import { MovimientoInventarioRegistrado } from "./MovimientoInventarioRegistrado.event.js";
import { PeriodoInventarioCerrado } from "./PeriodoInventarioCerrado.event.js";
// persistencia global
import { eventStore } from "../../../shared/repository/events/EventStore.js";

async function guardarEvento(event) {
  await eventStore.save(event);
}

domainEventDispatcher.register(MovimientoInventarioRegistrado.name, guardarEvento);
domainEventDispatcher.register(MovimientoInventarioActualizado.name, guardarEvento);
domainEventDispatcher.register(PeriodoInventarioCerrado.name, guardarEvento);